<h1 mat-dialog-title>Rezerwacja obejmuje kilka ofert. Wybierz tę, którą chcesz edytować:</h1>
<mat-dialog-content class="d-flex flex-row flex-nowrap gap-3 align-items-start">
	@for (offer of offers; track offer.id) {
		<mat-card
			appearance="outlined"
			(click)="selectOffer(offer.id)"
			class="flex-shrink-0 card-size"
			[ngClass]="{ selectedOffer: offer.id === selectedOfferId() }"
		>
			<mat-card-header>
				<mat-card-title>{{ offer?.status }} {{ offer.product.name }}</mat-card-title>
			</mat-card-header>
			<mat-card-content class="d-flex flex-column justify-content-center align-items-start h-100">
				@if (offer.id === selectedOfferId()) {
					<i class="fa-solid fa-circle-check position-absolute fs-4 text-success top-right-position"></i>
				}
				<span>
					@if (offer.roomType === null) {
						Express
					} @else {
						{{ offer.roomType?.code }} {{ offer.roomType?.name }}
					}
				</span>
				<span>
					{{ offer.board.name }}
				</span>
				<span>
					{{ offer.term?.dateRange.lower }} -
					{{ offer.term?.dateRange.upper }}
				</span>

				<span>
					{{ offer.totalPrice - offer.additionalRoomSizeCharge | price }}
					PLN
					@if (offer.additionalRoomSizeCharge) {
						| Dopłata:
						<span class="mt-0 fw-bold">{{ offer.additionalRoomSizeCharge | price }} PLN</span>
					}
				</span>
			</mat-card-content>
		</mat-card>
	}
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-raised-button color="warn" mat-dialog-close>Anuluj</button>
	<button mat-raised-button color="primary" (click)="submitAndCloseDialog()">Potwierdź</button>
</mat-dialog-actions>
